var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import axios from "axios";
import { getAppRoot } from "@/onload/loadConfig";
export const useWorkflowStore = defineStore("workflowStore", {
    state: () => ({
        workflowsByInstanceId: {},
    }),
    getters: {
        getWorkflowByInstanceId: (state) => {
            return (workflowId) => {
                return state.workflowsByInstanceId[workflowId];
            };
        },
        getWorkflowNameByInstanceId: (state) => {
            return (workflowId) => {
                const details = state.workflowsByInstanceId[workflowId];
                if (details && details.name) {
                    return details.name;
                }
                else {
                    return "...";
                }
            };
        },
        getStoredWorkflowIdByInstanceId: (state) => {
            return (workflowId) => {
                const storedWorkflow = state.workflowsByInstanceId[workflowId];
                return storedWorkflow === null || storedWorkflow === void 0 ? void 0 : storedWorkflow.id;
            };
        },
    },
    actions: {
        fetchWorkflowForInstanceId(workflowId) {
            return __awaiter(this, void 0, void 0, function* () {
                console.debug("Fetching workflow details for", workflowId);
                const params = { instance: "true" };
                const { data } = yield axios.get(`${getAppRoot()}api/workflows/${workflowId}`, { params });
                this.$patch((state) => {
                    state.workflowsByInstanceId[workflowId] = data;
                });
            });
        },
    },
});
